import { Link } from "react-router"
import { CheckCircle2 } from "lucide-react"
import { Button } from "@/components/ui/button"

export function EmailConfirmedPage() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-[400px] text-center">
        {/* Success icon */}
        <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
          <CheckCircle2 className="h-7 w-7 text-primary" />
        </div>

        <h1 className="text-xl font-semibold text-foreground mb-2">You're in!</h1>
        <p className="text-sm text-muted-foreground leading-relaxed mb-8">
          Your email is confirmed and your account is ready. Let's set up your first property.
        </p>

        <Button asChild className="w-full">
          <Link to="/properties">Enter Stayframe</Link>
        </Button>
      </div>
    </div>
  )
}
